var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduceVideo",attrs:{"id":"videoDiv"}},[_c('video',{staticClass:"video_class",attrs:{"id":"video","src":_vm.url,"controls":"","preload":"","webkit-playsinline":"","x-webkit-airplay":"","playsinline":"","x5-playsinline":"","poster":_vm.coverUrl,"width":_vm.width,"height":_vm.height}},[_vm._v(" 您的浏览器不支持 video 标签。 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }